import Service from "./service"

const getBonus = async ({ commit }: any) => {
  return Service()
    .showBonus()
    .then(async result => {
      await commit("save_bonus", result.data)
    })
}

export default {
  getBonus,
}
